import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Upload.svg?component
var Upload_exports = /* @__PURE__ */ __exportAll({
	default: () => Upload_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M12 4.33v15.32m5.37-9.95L12 4.33 6.63 9.7"
	}, null, -1)])]);
}
var Upload_default = { render: render$1 };
//#endregion
export { Upload_exports, Upload_default as default, render$1 as render };

//# sourceMappingURL=Upload.svg_component.js.map